import React, { useEffect, useState } from 'react';

import { RouteComponentProps } from 'react-router';

import { useOrgOnboardingContext } from '../../../contexts/OrgOnboardingContext';
import { useUserOnboardingContext } from '../../../contexts/UserOnboardingContext';

import { SetPasswordView as BaseSetPasswordView } from '../../common/SetPasswordView';

import { OnboardingSetPasswordFormValue } from '../../../components';

export type SetPasswordViewProps = RouteComponentProps<{ hash?: string }> & {
  goBackStep: (isLicensedApproved: boolean, claimHash: string) => () => void;
  handleGoNextStep: () => void;
};

const SetPasswordView = (props: SetPasswordViewProps) => {
  const { goBackStep, handleGoNextStep } = props;
  const { getSearchParam } = useOrgOnboardingContext();
  const userOnboardingContext = useUserOnboardingContext();
  const [redirectNextStep, setRedirectNextStep] = useState<boolean>(false);

  const verifyHash = getSearchParam('verifyHash');
  const isApproved = getSearchParam('approved') === 'true';
  const isLicensed = getSearchParam('isLicensed') === 'true';

  const handleSubmit = async (values: OnboardingSetPasswordFormValue) => {
    userOnboardingContext.setNewPassword(values.password);
    setRedirectNextStep(true);
  };

  useEffect(() => {
    if (redirectNextStep) {
      handleGoNextStep();
    }
  }, [redirectNextStep, handleGoNextStep]);

  if (redirectNextStep) {
    return null;
  }

  return (
    <BaseSetPasswordView
      handleSubmit={handleSubmit}
      handleGoBackStep={goBackStep(isLicensed && isApproved, verifyHash)}
    />
  );
};

export default SetPasswordView;
